<script setup lang="ts">
import { ref } from 'vue'
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { logError } from '@/lib/util'
import emitter, { AppEvents } from '@/lib/events'
import Config from '@/config'
import { RouteLogin } from '@/router/routes'
import Toast from '@/components/Toast.vue'
import { useESSettingsStore } from 'escs-frontend-library'

const store = useStore()
const router = useRouter()
const route = useRoute()
const toast = ref(null)
const isAppReady = ref(false)
const esSettingsStore = useESSettingsStore()

const updateAppUIMode = () => {
	const theme = typeof route.query.theme === 'string' && esSettingsStore.isValid(route.query.theme.toUpperCase())
		? route.query.theme.toLowerCase()
		: 'lightmode'
	document.documentElement.classList.add(theme)
	esSettingsStore.setTheme(theme)
}

const showToast = payload => {
	toast.value = payload

	if (payload.timeout != null && payload.timeout > 0) {
		const tid = setTimeout(() => {
			toast.value = null
			clearTimeout(tid)
		}, payload.timeout)
	}
}

const init = async () => {
	console.log(import.meta.env.PACKAGE_VERSION)

	try {
		console.log("APP INIT")
		esSettingsStore.setStorageUrl(Config.storageUrl)
		await store.dispatch('effects/loadUserCredentials')

		console.log('APP AUTHED')
		if (store.getters.isAuthenticated) {
			await store.dispatch('loadUser')
		}
	} catch (error) {
		logError(error)

		if (!(store.getters.isAuthenticated && store.getters.pendingAccountConfirmation)) {
			store.dispatch('logout')
			await router.isReady()
			router.replace({ name: RouteLogin })
		}
	}

	emitter.on('*', (type, payload) => {
		//Config.isLoggingEnabled && console.log('app event', type, payload)

		switch (type) {
			case AppEvents.Navigate:
				router.replace({ path: payload.path })
				break;
			case AppEvents.ShowToast:
				console.log('show toast', payload)
				showToast(payload)
				break
			case AppEvents.HideToast:
				toast.value = null
				break
			default:
				break;
		}
	})
	isAppReady.value = true
}

void init().catch(logError)
router.isReady().then(() => updateAppUIMode())

</script>

<template lang="pug">
.toast-container
	transition(name="toast-slide")
		Toast(
			v-if="toast"
			:type="toast.type"
			:message="toast.message"
			@dismiss="toast = null")
router-view(v-if="isAppReady")
#overlay
</template>

<style src="./styles/index.css" lang="css"></style>
<style src="./styles/fonts.css" lang="css"></style>
<style scoped>
.toast-container {
	@apply fixed top-0 inset-x-0 z-50 sm:top-3 sm:left-1/2 sm:right-auto sm:transform sm:-translate-x-1/2 sm:w-full sm:max-w-md;
}

.toast-slide-enter-active,
.toast-slide-leave-active {
	transition: all .3s ease;
}

.toast-slide-enter-from,
.toast-slide-leave-to {
	transform: translateY(-100%);
	opacity: 0;
}
</style>
